export default "<p>admin-by-pass-client-login works!</p>\r\n"